<template>
<div class="chapter">
<div class="inner_page">
<h2 class="bm-title">TABLE OF CONTENTS</h2>
<p class="toc-part"><a href="#/xhtml/part01"><span class="bold">I. Floundering: Why Work Fails Us</span></a></p>
<p class="toc-chap"><a href="#/xhtml/chap01"><span class="toc-no">Chapter 1</span> Putting a Finger on the Best Part of Work</a></p>
<p class="toc-chap"><a href="#/xhtml/chap02"><span class="toc-no">Chapter 2</span> Putting Money in Its Place</a></p>
<p class="toc-chap"><a href="#/xhtml/chap03"><span class="toc-no">Chapter 3</span> Aiming Higher</a></p>
<p class="toc-part"><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="bold">II. Job Purposing: Do Good at Work to Do Great in Life</span></span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="toc-no">Chapter 4</span> What Job Purposing Is</span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="toc-no">Chapter 5</span> What Job Purposing Is Not</span></p>
<p class="toc-chap"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="toc-no">Chapter 6</span> A Dozen Ways to Job Purpose</span></p>
<p class="toc-chap"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="toc-no">Chapter 7</span> Managing the Difficulties and Risks of Job Purposing</span></p>
<p class="toc-chap"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="toc-no">Chapter 8</span> The Risks and Costs of Not Job Purposing</span></p>
<p class="toc-chap"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="toc-no">Chapter 9</span> The Possibility of Lyricism</span></p>
<p class="toc-part"><span href="#/xhtml/part03" title="Link target outside of Sample"><span class="bold">III. Managing: Job Purposing for Teams and Organizations</span></span></p>
<p class="toc-chap"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="toc-no">Chapter 10</span> The Business Benefits of Job Purposing</span></p>
<p class="toc-chap"><span href="#/xhtml/chap11" title="Link target outside of Sample"><span class="toc-no">Chapter 11</span> The Drivers of Highly Transformative Job Purposing</span></p>
<p class="toc-part"><span href="#/xhtml/part04" title="Link target outside of Sample"><span class="bold">IV. Evolving: The Ultimate Reason to Job Purpose</span></span></p>
<p class="toc-chap"><span href="#/xhtml/chap12" title="Link target outside of Sample"><span class="toc-no">Chapter 12</span> Becoming Our True Selves</span></p>
<p class="toc-chap"><span href="#/xhtml/chap13" title="Link target outside of Sample"><span class="toc-no">Chapter 13</span> Changing the World</span></p>
<p class="toc-chap"><span href="#/xhtml/chap14" title="Link target outside of Sample"><span class="toc-no">Chapter 14</span> Becoming Weightless</span></p>
<p class="toc-bmt"><span href="#/xhtml/bm01" title="Link target outside of Sample">About the Author</span></p>
<p class="toc-bm"><span href="#/xhtml/bm02" title="Link target outside of Sample">Endnotes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?35d75368